<template>
    <div class="custom_radio tw-relative tw-flex tw-items-center">
        <input type="radio"
               :id="id"
               :name="name"
               :value="initialValue"
               class="tw-w-4 tw-h-4 tw-absolute tw-top-0 tw-left-0 tw-opacity-0"
               :class="classes"
               v-model="checked"
               @change="onChange"
        >
        <div class="tw-flex tw-justify-center tw-items-center tw-w-4 tw-h-4 tw-border tw-border-brand-info tw-rounded-full tw-mr-2">
            <div class="tw-w-2 tw-h-2 tw-rounded-full"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: {},
            id: {
                required: true,
                type: String,
            },
            name: {
                required: true,
                type: String,
            },
            initialValue: {
                required: false,
                default: '',
            },
            classes: {
                required: false,
                type: String,
                default: '',
            }
        },
        data() {
            return {
                checkedProxy: false
            }
        },
        computed: {
            checked: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.checkedProxy = val;
                }
            }
        },
        methods: {
            onChange: function (e) {
                this.$emit('input', this.checkedProxy)
            }
        }
    }
</script>